<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { useMainStore } from "@/store/main/index";

withDefaults(
  defineProps<{
    title: string;
    noTranslate?: boolean;
  }>(),
  {
    noTranslate: true,
  }
);

const mainStore = useMainStore();
</script>

<template>
  <h1
    class="section-title hl-1-plus c-dark-blue"
    v-if="title"
    :class="'section-title--' + mainStore.lang"
  >
    {{ noTranslate ? title : $t(title?.toLowerCase()) }}
  </h1>
</template>
